import user_Store from '../store/user_store'
import Button from 'react-bootstrap'
function NotFound_Page() {
  const user = user_Store((state) => state.user)

  return <div className='NotFound'>404 Not Found </div>
}

export default NotFound_Page
